export const ROTULO_CAMPO_FIXO: Record<string, string> = {
  CONTATO_NOME: 'Nome do cliente',
  CONTATO_NUMERO: 'Número do cliente',
  OPERADOR_NOME: 'Nome do operador',
};

export const LINHAS_SKELETON = [1, 2, 3, 4, 5];

export const LARGURA_MINIMA_DUAS_COLUNAS = 640;
